import { Helmet } from "react-helmet-async";
import images from "../../images";
import {
  useGetUserInfoQuery,
  useGetUnreadInboxCountQuery,
} from "../../services/apiSlice";
import { useNavigate } from "react-router-dom";
import { cn } from "../../Utils/helper";
import { useEffect } from "react";

const NewHeader = ({
  backgroundHeader,
  handleSignIn,
  handleSignUp,
  className = "",
}) => {
  const accessToken =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");
  const refreshToken =
    localStorage.getItem("refreshToken") ||
    sessionStorage.getItem("refreshToken");
  const isAuthenticated = accessToken || refreshToken;

  const { data: userInfo } = useGetUserInfoQuery(undefined, {
    skip: !isAuthenticated,
  });
  const { data: unreadData } = useGetUnreadInboxCountQuery(undefined, {
    skip: !isAuthenticated,
  });
  const unreadCount = unreadData?.total || 0;

  const navigate = useNavigate();
  useEffect(() => {
    if (userInfo?.data?.id) {
      localStorage.setItem("customUserId", userInfo.data.id);
      localStorage.setItem("userInfo", JSON.stringify(userInfo.data));
    }
  }, [userInfo]);

  return (
    <header
      className={cn(
        `py-3 w-full mx-auto rounded-none ${
          backgroundHeader ? backgroundHeader : "bg-white"
        } `
      )}
    >
      <Helmet>
        <meta name="theme-color" content="#FFFFFF" />
      </Helmet>
      <div
        className={cn(
          `flex flex-1 justify-between items-center w-full max-w-[368px] mx-auto ${className}`
        )}
      >
        <div
          className="flex gap-2 items-center cursor-pointer"
          onClick={() => navigate("/")}
        >
          <img
            src={images.RallyLogo2}
            alt="Rally Logo"
            className="w-[100px] h-[11px] object-contain"
          />
        </div>
        {userInfo?.data ? (
          <div
            onClick={() => navigate("/profile")}
            className="relative bg-[#253FF6] flex justify-between items-center rounded-md text-white px-1.5 py-3 h-[30px] gap-3 cursor-pointer hover:bg-blue-700 transition-colors"
          >
            <div className="flex gap-1.5 items-center">
              <img
                src={images.RallyCoinSprint5}
                alt="Coin"
                className="w-[15px] h-[15px] object-contain"
              />
              <p className="text-lg  font-bold max-w-[60px] truncate">
                {userInfo?.data?.token ? parseInt(userInfo?.data?.token) : 0}
              </p>
            </div>
            {/* <div className="flex gap-[5px] items-center">
              <img
                src={images.RallyXPSmallWhiteIcon}
                alt="XP"
                className="w-[15px] h-[15px] object-contain"
              />
              <p className="text-sm sm:text-lg font-bold max-w-[60px] truncate">
                {userInfo?.data?.xp ? parseInt(userInfo?.data?.xp) : 0}
              </p>
            </div>

            <div className="flex items-center shrink-0">
              <img
                src={images.UserSmallWhiteIcon}
                alt="User"
                className="w-[24px] h-[24px] object-contain"
              />
            </div> */}
            {unreadCount > 0 && (
              <div className="absolute top-[-5px] right-[-5px] bg-red-500 text-white font-bold rounded-full w-[18px] h-[18px] flex items-center justify-center text-[9px] border-white border-2">
                {unreadCount > 99 ? "99+" : unreadCount}
              </div>
            )}
          </div>
        ) : (
          <div className="flex flex-row text-[#253FF6] text-sm font-bold gap-3">
            <span onClick={handleSignUp} className="cursor-pointer">
              Sign Up
            </span>{" "}
            <span onClick={handleSignIn} className="cursor-pointer">
              Log in
            </span>
          </div>
        )}
      </div>
    </header>
  );
};

export default NewHeader;
